import { Component, Vue } from 'vue-property-decorator';
import { store, mutations } from '@/store/store';

@Component
export default class Loader extends Vue {
    // Get loading state from store
    protected get isLoading(): boolean { return store.state.dataLoading; }
}
